import api from './api';

const annonceService = {
  // Récupérer toutes les annonces actives
  getAds: async (params = {}) => {
    try {
      // console.log('Fetching ads from:', '/annonces');
      const response = await api.get('/annonces', { params });
      // console.log('Ads response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching ads:', error);
      throw error;
    }
  },

  // Récupérer une annonce par ID
  getAd: async (id) => {
    try {
      // console.log('Fetching ad by ID:', id);
      const response = await api.get(`/annonces/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching ad:', error);
      throw error;
    }
  }
};

export default annonceService;
